import { State } from 'app/redux';

export const getPermissionGroupsAll = (state: State) =>
  state.permissionGroups.permissionGroups;

export const getPricingRules = (state: State) =>
  getPermissionGroupsAll(state).items;

export const getSearches = (state: State) => state.permissionGroups.searches;
